import React from 'react';
import { Datagrid, FunctionField, useTranslate } from 'react-admin';
import SimpleList from '@/components/global/list/SimpleList.jsx';
import NotificationBox from '@/components/global/fields/NotificationBox.jsx';
import ListCollectionPointField from '@/components/collectionPoint/ListCollectionPointField.jsx';
import DeviceListServiceStatusField from '@/components/device/DeviceListServiceStatusField.jsx';
import { DeviceStateField } from '@/components/device/fields/DeviceStateField.jsx';
import MoreActionsPopover from '@/components/device/DeviceMoreActionsPopover.jsx';
import { useDrawer } from '@/composables/useDrawer';
import { DrawerLink } from '@/components/global/drawers/DrawerLink.jsx';
import { Palette } from '@/themes/themeOverrides/Palette';

const GroupDevicesList = ({ record }) => {
    const { openDrawer } = useDrawer();
    const translate = useTranslate();
    return (
        <SimpleList
            resource='device'
            filterDefaultValues={{ groupId_in: [record.id] }}
            sort={{ field: 'createdAt', order: 'DESC' }}
            hasCreate={false}
            className='extended-table'
            empty={
                <NotificationBox variant='info' className='large'>
                    {translate('resources.deviceGroup.labels.noDevices')}
                </NotificationBox>
            }
        >
            <Datagrid bulkActionButtons={false}>
                <FunctionField
                    source='serialNumber'
                    label={translate('resources.device.fields.serialNumber')}
                    render={record => <DrawerLink resource='device' action='show' source={record.id} label={record.serialNumber} relative />}
                />
                <FunctionField
                    source='collectionPoint.id'
                    label={translate('common.collectionPoint')}
                    sortBy='collectionPoint.customId'
                    render={record => (
                        <ListCollectionPointField
                            collectionPoint={record.collectionPoint}
                            sx={{ cursor: 'pointer' }}
                            onClick={e => {
                                e.stopPropagation();
                                openDrawer(record.collectionPoint.id, 'collection-point-show');
                            }}
                        />
                    )}
                />
                <FunctionField
                    label={translate('resources.device.fields.serviceStatus')}
                    sortBy='serviceStatus'
                    render={record => <DeviceListServiceStatusField record={record} />}
                />
                <FunctionField
                    label={translate('resources.device.fields.deploymentStatus')}
                    render={record => <DeviceStateField record={record} />}
                    sortBy='state'
                />
                <FunctionField
                    label={translate('common.options')}
                    sx={{
                        '& .MuiButtonBase-root.MuiIconButton-root': {
                            backgroundColor: Palette.gray.gray150,
                            '&:hover': {
                                backgroundColor: Palette.gray.gray100,
                                outline: `2px solid ${Palette.gray.gray300}`,
                                outlineOffset: '-2px',
                            },
                        },
                    }}
                    onClick={e => e.stopPropagation()}
                    render={record => <MoreActionsPopover record={record} />}
                />
            </Datagrid>
        </SimpleList>
    );
};

export default GroupDevicesList;
